"use client";
import React, { useState, useEffect } from 'react';
import Link from 'next/link';

const StickyMobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    // Show CTA after scrolling past hero section
    const handleScroll = () => {
      const heroSection = document.getElementById('community-hero');
      if (heroSection) {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        setIsVisible(heroBottom < 0 && isMobile);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile]);

  if (!isMobile || !isVisible) return null;

  return (
    <div
      className="d-md-none position-fixed bottom-0 start-0 end-0 p-3"
      style={{
        background: 'linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.95) 20%, rgba(0, 0, 0, 0.98) 100%)',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.3)',
        animation: 'slideUp 0.3s ease-out',
        zIndex: 1050
      }}
    >
      <Link
        href="/signup"
        className="btn w-100 btn-lg px-4 py-3 rounded-pill fw-bold text-dark d-flex align-items-center justify-content-center"
        style={{
          background: 'linear-gradient(135deg, #FFD52E 0%, #FF8C00 100%)',
          border: 'none',
          boxShadow: '0 4px 20px rgba(255, 213, 46, 0.5)',
          fontSize: '1.125rem',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.02)';
          e.target.style.boxShadow = '0 6px 25px rgba(255, 213, 46, 0.6)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 4px 20px rgba(255, 213, 46, 0.5)';
        }}
      >
        <i className="bi bi-person-plus-fill me-2"></i>
        انضم للمجتمع الآن
        <i className="bi bi-arrow-left ms-2"></i>
      </Link>
      
      <style jsx>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default StickyMobileCTA;
